export const TRANSLATION_ASSIGNMENT_NAME = 'translation';
